export default __webpack_public_path__ + "static/media/BeaconLogo.eddf12ec.svg";